// extracted by mini-css-extract-plugin
export var checkbox = "_6q-0";
export var circle = "_6q-3";
export var horizontalContainer = "_6q-7";
export var sm = "_6q-5";
export var switch0 = "_6q-2";
export var switchDisabled = "_6q-8";
export var switchEnabled = "_6q-1";
export var textSwitchContainer = "_6q-9";
export var textSwitchOption = "_6q-a";
export var textSwitchOptionSelected = "_6q-b";
export var verticalContainer = "_6q-6";
export var xs = "_6q-4";